import React from 'react';
const variants = {
  primary: { background: '#534AB7', color: '#fff', border: 'none' },
  secondary: { background: '#fff', color: '#333', border: '1px solid #d3d1c7' },
  danger: { background: '#A32D2D', color: '#fff', border: 'none' },
  success: { background: '#3B6D11', color: '#fff', border: 'none' },
  warning: { background: '#BA7517', color: '#fff', border: 'none' },
  ghost: { background: 'transparent', color: '#534AB7', border: '1px solid #534AB7' },
};
export default function Btn({ children, variant = 'primary', onClick, type = 'button', disabled, size = 'md', style = {} }) {
  const v = variants[variant] || variants.primary;
  const sz = size === 'sm' ? { padding: '6px 12px', fontSize: 13 } : { padding: '9px 18px', fontSize: 14 };
  return <button type={type} onClick={onClick} disabled={disabled}
    style={{ ...v, ...sz, borderRadius: 8, fontWeight: 500, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1, ...style }}>{children}</button>;
}
